import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_filter_list_element = _resolveComponent("filter-list-element")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inputItems, (element, index) => {
    return (_openBlock(), _createBlock(_component_filter_list_element, {
      modelValue: _ctx.inputItems[index],
      "onUpdate:modelValue": ($event: any) => ((_ctx.inputItems[index]) = $event),
      key: 'filt_'+index,
      "input-index": index,
      "parent-id": undefined,
      "parent-name": '',
      "parent-idx": 'filt_'+index
    }, null, 8, ["modelValue", "onUpdate:modelValue", "input-index", "parent-idx"]))
  }), 128))
}